import apiClient from '@/api/client';
import { PlatformDevice } from '@/models/platformDevice';

export const PlatformDevicesService = {
    async getAll(): Promise<PlatformDevicesResponse> {
        const response = await apiClient.get<PlatformDevicesResponse>('/platform/devices');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve platform device export.');
        }

        return result;
      },
}

export interface PlatformDevicesResponse {
    devices: PlatformDevice[]
}
